import { render } from "./BaglantiKesintisi.vue?vue&type=template&id=6a8b5b9e"
import script from "./BaglantiKesintisi.vue?vue&type=script&lang=js"
export * from "./BaglantiKesintisi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__